"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const getPadding = (prop, factor) => ({ pageWidth, page: { sectionSpacing } }) => [
    pageWidth,
    ...(0, utils_1.keys)(sectionSpacing).map((m) => app_1.styled[m]({
        [prop]: `${(0, utils_1.multiplyCssValue)(factor, sectionSpacing[m])}${prop === 'padding' ? ' 0' : ''}`,
    })),
];
const firstStyle = getPadding('paddingTop', 1);
const lastStyle = getPadding('paddingBottom', 1);
const StyledDiv = app_1.styled.div `
  ${getPadding('padding', 0.5)}
  ${(_, { $first, $last }) => (0, app_1.css) `
    ${$first && firstStyle}
    ${$last && lastStyle}
  `}
`;
const StyledSection = app_1.styled.section `
  ${(theme, { $css }) => (0, app_1.css) `
    background-color: ${theme.background};
    ${$css}
  `};
`;
exports.Section = (0, react_1.forwardRef)(({ className, id, outerCss, children, context, only = false, first = only, last = only, }, ref) => {
    const render = (0, react_1.useCallback)((props) => ((0, jsx_runtime_1.jsx)(StyledSection, Object.assign({ "$css": outerCss }, props))), [outerCss]);
    return ((0, jsx_runtime_1.jsx)(app_1.Context, Object.assign({ name: context, render: render }, { children: (0, jsx_runtime_1.jsx)(StyledDiv, Object.assign({ className: className, "$first": first, "$last": last, ref: ref, id: id }, { children: children })) })));
});
